module.exports = __webpack_public_path__ + "img/t3-blue.a1a76349.png";